import { PostTypes } from 'constants/postTypes'
import { Linking } from 'react-native'

import { Clipboard } from 'utils/Clipboard'
import { externalLinks } from 'utils/constants'
import { Toast } from 'utils/toast'

import { UserType } from 'types/user'

import { generateDynamicLink } from './generateDynamicLink'

export const openExternalLink = (
  url: string,
  options = {
    newTab: true,
  },
): void => {
  if (!url) return

  if (options.newTab) {
    window.open(url, '_blank')
  } else {
    window.open(url, '_self')
  }
}

export const openReportForm = (
  currentUser: UserType | null | undefined,
  userReported: UserType | null | undefined,
) => {
  Linking.openURL(
    `https://share.hsforms.com/1mLgiOxuJSwuEcfoRnKFPAwcaljb?reporter_name=${
      currentUser?.firstName
    } ${currentUser?.lastName}&reporter_username=${currentUser?.username}&upspace_username=${
      userReported?.username ?? ''
    }&firstname=${userReported?.firstName ?? ''}&lastname=${userReported?.lastName ?? ''}`,
  )
}

export const getUpspaceLink = (username: string): string => {
  return `${externalLinks.UPSPACE_FULL_PATH}/group/${username}`.toLocaleLowerCase()
}

export const getProgramLink = (username: string): string => {
  return `${externalLinks.UPSPACE_FULL_PATH}/program/${username}`.toLocaleLowerCase()
}

export const copyUpspaceUrl = async (username: string): Promise<void> => {
  const referralLink = await generateDynamicLink(getUpspaceLink(username))
  Clipboard.setString(referralLink)
  Toast.success(
    'Copied to clipboard!',
    'We copied the Group link to your clipboard!',
    undefined,
    {},
    true,
    'bottom',
    undefined,
    undefined,
    true,
  )
}

export const getProfileLink = (username: string): string => {
  return `${externalLinks.UPSPACE_FULL_PATH}/profile/member/${username}`.toLocaleLowerCase()
}

export const copyProfileUrl = async (username: string): Promise<void> => {
  const referralLink = await generateDynamicLink(getProfileLink(username))
  Clipboard.setString(referralLink)
  Toast.success(
    'Copied to clipboard!',
    'We copied the profile link to your clipboard!',
    undefined,
    {},
    true,
    'bottom',
    undefined,
    undefined,
    true,
  )
}

export const getPostLink = (postId: string, postType: PostTypes, completionId?: string): string => {
  if (postType === PostTypes.ACTIVITY && completionId) {
    return `${externalLinks.UPSPACE_FULL_PATH}/post/${postId}?completionId=${completionId}`
  }
  return `${externalLinks.UPSPACE_FULL_PATH}/post/${postId}`
}

export const getPostLinkMessage = (postType: PostTypes, hasMedia: boolean): string => {
  if (postType === PostTypes.ACTIVITY) {
    if (hasMedia) {
      return `I just completed this. It's your turn!`
    }
    return `I completed an activity on Upspace, now it's your turn!`
  }

  return `Check out this ${postType === PostTypes.WORKOUT ? 'workout' : 'post'} on Upspace!`
}

export const copyLinkToClipboard = (url: string) => {
  Clipboard.setString(url)
  Toast.success('Copied to clipboard!', url, true, {}, true, 'bottom', undefined, undefined, true)
}
